module.exports = __webpack_public_path__ + "static/media/florianopolis-sc.c277637b.jpg";